import { render, staticRenderFns } from "./delivery-test-debug.vue?vue&type=template&id=40a60e79"
import script from "./delivery-test-debug.vue?vue&type=script&lang=js"
export * from "./delivery-test-debug.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports